import React, { useContext, useEffect } from "react";
import { CategoryContext } from "../../contexts/CategoryContext";
import { Link } from "react-router-dom";

// Mapping nom de catégories → image de couverture par défaut
const categoryImages = {
  Homme:
    "https://images.unsplash.com/photo-1567898551277-e20520e859e7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c3R5bGUlMjBibGFjayUyMG1lbnxlbnwwfHwwfHx8MA%3D%3D",
  Femme:
    "https://images.unsplash.com/photo-1601326374180-e118ac4f7af4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c3R5bGUlMjBibGFjayUyMHdvbWVufGVufDB8fDB8fHww",
  Enfant:
    "https://plus.unsplash.com/premium_photo-1674769116099-d70d710ebb30?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YmFieSUyMGJsYWNrfGVufDB8fDB8fHww",
  Food: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c",
  Cosmétique:
    "https://images.unsplash.com/photo-1600428853876-fb5a850b444f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c2tpbiUyMGNhcmV8ZW58MHx8MHx8fDA%3D",
  Santé:
    "https://images.unsplash.com/photo-1543362906-acfc16c67564?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGhlYWx0aHxlbnwwfHwwfHx8MA%3D%3D",
  Ferme:
    "https://images.unsplash.com/photo-1606677661991-446cea8ee182?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVhdHxlbnwwfHwwfHx8MA%3D%3D",
  Vivriers:
    "https://images.unsplash.com/photo-1516594798947-e65505dbb29d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Z3JvY2VyeXxlbnwwfHwwfHx8MA%3D%3D",
  Hebergement:
    "https://plus.unsplash.com/premium_photo-1661962841993-99a07c27c9f4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8aG91c2V8ZW58MHx8MHx8fDA%3D",
  "Telephone et tablette":
    "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cGhvbmV8ZW58MHx8MHx8fDA%3D",
  "TV et Electronics":
    "https://media.istockphoto.com/id/1603700869/fr/photo/parcourir-le-film-sur-le-service-de-diffusion-multim%C3%A9dia-en-continu.webp?a=1&b=1&s=612x612&w=0&k=20&c=yzK_Xfy0IPjFrcn8Ra16X2lqpJv7AWUncWFjDtQnvdU=",
  Poissonnerie:
    "https://media.istockphoto.com/id/2164133055/fr/photo/filet-de-bar.webp?a=1&b=1&s=612x612&w=0&k=20&c=HNnC1QSTE425JDKIm2uM2QlhLX1QqyFU8B2rZ0U-ojU=",
  Restauration:
    "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZmFzdCUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
  Coiffure:
    "https://images.unsplash.com/photo-1529123202249-4f6224196c9b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YmxhY2slMjBoYWlyfGVufDB8fDB8fHww",
  "Equipement domestique":
    "https://images.unsplash.com/photo-1523495274380-d81bca299da7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8aG91c2UlMjBjbGVhbnxlbnwwfHwwfHx8MA%3D%3D",
  Automobile:
    "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGNhcnxlbnwwfHwwfHx8MA%3D%3D",
  Informatique:
    "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGxhcHRvcHxlbnwwfHwwfHx8MA%3D%3D",
};

const CategoryGrid = () => {
  const { categories, getAllCategories } = useContext(CategoryContext);

  useEffect(() => {
    getAllCategories();
  }, [getAllCategories]);

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-6">Toutes les catégories</h2>

      {categories.length > 0 ? (
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-col-4 xl:grid-cols-6 gap-4">
          {categories.map((cat) => {
            const image =
              categoryImages[cat.category] || "https://via.placeholder.com/150";

            return (
              <Link
                to={`/allProducts/${encodeURIComponent(cat.category)}`}
                key={cat._id}
                className="border p-2 rounded-lg shadow bg-white text-center hover:shadow-xl transition-all"
              >
                <img
                  src={image}
                  alt={cat.category}
                  className="w-full h-24 object-cover rounded-lg mb-2"
                />
                <p className="text-sm font-semibold text-[#FF8624] truncate">
                  {cat.category}
                </p>
              </Link>
            );
          })}
        </div>
      ) : (
        <p className="text-sm text-gray-500">Aucune catégorie disponible.</p>
      )}
    </div>
  );
};

export default CategoryGrid;
